angular.module('swapick')
.controller('OwnedCtrl', OwnedCtrl);


function OwnedCtrl($scope, DataService, DataStrategies, $ionicScrollDelegate,
  initialLoaderManager, $q, $ionicPopup, Entities, $timeout) {

  DataStrategies.createPagerMethods(this, $scope,
    {
      method:DataService.owned, pageSize:50,
      callMethodName:'getList', hasSearch:true,
      params : () => ({
        q : this.searchString
      })
    }
  );

  this.dropObject = (obj, idx) => {

    var confirmPopup = $ionicPopup.confirm({
      title: 'Rimozione oggetto',
      template: 'Confermi di non possedere più questo oggetto?'
    });

    confirmPopup.then((res) => {
      if(res) {
         DataService.owned
        .one(obj.id.toString())
        .remove()
        .then(resp=>{
          this.objects.splice(idx, 1);
        })
      } else {
         console.log('You are not sure');
      }
    });

  }


  this.loader = initialLoaderManager.makeLoader(()=> {
    return Entities.waitForUser()
    .then(u => {
      this.user = u
      return this.loadMore()
    })
  }, false);


  $scope.$on('$ionicView.beforeEnter', () => {
      if(!this.objects.length){
        this.loader.load();
      }
  });


}



// WEBPACK FOOTER //
// ./src/controllers/owned-controller.js